import { createReducer } from '@reduxjs/toolkit';
import _ from 'lodash';
import { TYPES } from '../../common/constants';

const setPRLoaderLoadingDone = () => {
    return true
};

const stopPRLoaderLoadingDone = () => {
    return false
}




const initialState = false;

export default createReducer(initialState, {
  [TYPES.SET_PRLOADER_LOADING]: setPRLoaderLoadingDone,
  [TYPES.STOP_PRLOADER_LOADING]: stopPRLoaderLoadingDone,
});
